import { OBJ_FDI_PARAMS } from './../wells-compare-data.service';
import { RealtimeTreatmentStorageService, KEY_TEMPLATE, PAD_COMPARE_PARAM_SINGLE_WELL } from './../../../shared/services/realtime-treatment-storage.service';
import { Component, OnInit, ViewChild, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import * as moment from 'moment';

import { ScatterPlotParameterChartComponent } from '../../../shared/components/charts';

import { IScatterChartInputState, IInputParamData, IScatterPlotChartSetting, IAxisSetting, ScatterPlotParameterChartService, ENUM_AXIS_TYPE } from '../../../shared/services/charts/scatter-plot-parameter-chart.service';
import { CompareWellsService } from '../../../shared/services/compare-wells.service';
import { isEmpty, cloneDeep, isEqual, includes, each } from 'lodash';
import { DefaultColor, DefaultShapes, EpochTimeParameters, ENUM_TREATMENT_COLUMNS, DEFUALT_DESIGN_ACUTAL_SHAPES, DEFAULT_DESIGN_COLOR, DEFAULT_ACTUAL_COLOR } from '../../../shared/helpers/app.constants';
import { ToasterService, LocalDataStorageService, KEY_DESIGN_ACTUAL_SETTING } from '../../../shared/services';
import { WellsCompareLogDataService, ITreatmentAvgMDItem } from '../wells-compare-log-data.service';
import { Observable, of, forkJoin, Subject } from 'rxjs';
import { ENUM_SCALE_TYPES, ILogDataState, LogDataCurveParameterChartService } from '../../../shared/services/charts/log-data-curve-parameter-chart.service';
import { finalize, tap, map, takeUntil } from 'rxjs/operators';
import { TreatmentService } from '../../../shared/services/treatment.service';
import { ITreatmentItem } from '../../../shared/models/treatment.model';
import { TreatmentLogParserService, ILogCurvesParam } from '../../../shared/services/treatment-log-parser.service';
import { ScatterPlotParameterSettingsComponent } from '../../../shared/components/modals/scatter-plot-parameter-settings/scatter-plot-parameter-settings.component';
import { IModelSelectParameters } from '../../../shared/components/select-parameters/select-parameters.component';
import { WellsCompareDataService } from '../wells-compare-data.service';
import { ITreatmentLogTemplateResponse } from '../../../shared/models/treatment-log-template.model';
import { CompareParameterSingleService } from './compare-parameter-single-well.service';


@Component({
  selector: 'app-compare-parameter-single-well',
  templateUrl: './compare-parameter-single-well.component.html',
  styleUrls: ['./compare-parameter-single-well.component.scss']
})
export class CompareParameterSingleWellComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();

  @ViewChild(ScatterPlotParameterChartComponent) scatterHighChart: ScatterPlotParameterChartComponent;

  scatterChartInputState: IScatterChartInputState;
  isDisplayTooltip = true;

  selectedTreatments: ITreatmentItem[] = [];
  listParameters = [];

  listXAxisOptions = [
    { id: 'time', text: 'Order (Time)' }
  ];

  listYAxisOptions = [];
  listISIPOptions = [];
  listPressureOptions = [];
  listSlurryRateOptions = [];
  listMassOptions = [];
  listVolumeOptions = [];
  listProppantConcOptions = [];
  listFDIOptions = [];
  listTimeOptions = [];

  selectedXAxisOption = [this.listXAxisOptions[0]];
  selectedYAxisOption = [];
  selectedDesignActualYAxisOption: any[] = [];

  selectedParameters = [];
  inputChartData: IInputParamData[];

  xAxisMode = 'time';

  defaultColors = DefaultColor;
  defaultShapes = DefaultShapes;

  itemsComparing = [];
  chartSettings: IScatterPlotChartSetting = {
    xAxis: null,
    yAxis: [],
    curveYAxis: [],
    designActualYAxis: []
  };
  designActualSettings = {
    designShape: DEFUALT_DESIGN_ACUTAL_SHAPES[0].id,
    actualShape: DEFUALT_DESIGN_ACUTAL_SHAPES[0].id,
    designColor: DEFAULT_DESIGN_COLOR,
    actualColor: DEFAULT_ACTUAL_COLOR
  };
  isDisabledXAxisOption = false;

  listScaleTypes = [
    { id: ENUM_SCALE_TYPES.VerticalSection, text: ENUM_SCALE_TYPES.VerticalSection },
    { id: ENUM_SCALE_TYPES.Treatment, text: ENUM_SCALE_TYPES.Treatment },
    { id: ENUM_SCALE_TYPES.MeasuredDepth, text: ENUM_SCALE_TYPES.MeasuredDepth },
  ];

  selectedScaleOption = [this.listScaleTypes[0]];

  listLogDataFiles$: Observable<any>;
  listCurves$: Observable<any> = of([]);
  listCurves: any[] = [];
  selectedLogFile = [];
  selectedCurve = [];
  logDataState: ILogDataState = {
    curveItem: null,
    scaleMode: ENUM_SCALE_TYPES.VerticalSection,
    curveData: [],
    logCurvesData: [],
    wellKickOfMD: null
  };

  treatmentAvgMDItems: ITreatmentAvgMDItem[] = [];
  trajectoryData: any[] = [];

  treatmentDetailsStored = {};
  designActualData: any = null;
  groupOption: string = 'treatment';

  xAxisOptionChange$: Subject<any> = new Subject();
  yAxisOptionChange$: Subject<any> = new Subject();
  curveOptionChange$: Subject<any> = new Subject();
  designActualOptionChange$: Subject<any> = new Subject();
  @Input() loadingTreatmentLogTemplates: boolean;
  dataTreatmentLogTemplates: ITreatmentLogTemplateResponse[] = [];


  @Input() wellItem;

  @Input()
  set singleWell(well) {
    const isLogDataFiles = this.isLogDataFiles(this.wellItem, well);
    this.wellItem = well;
    // get well trajectory data
    if (!!isLogDataFiles) {
      this.listLogDataFiles$ = this.wellsCompareLogDataService.getLogDataFiles(this.wellItem.wellId);
      this.getWellDetail(this.wellItem.wellId);
    }
  }

  @Input()
  set treatmentItems(data: any[]) {
    if (data) {
      data = data.map(item => {
        item.treatmentNumber = item.treatmentNumber || item.text;
        return item;
      });
      this.selectedTreatments = [...data];
      // sort selected treatments by treatmentNumber descending
      this.selectedTreatments.sort((a, b) => b.treatmentNumber - a.treatmentNumber);
      this.itemsComparing = this.selectedTreatments.map((item, index) => {
        const shapeIndex = index <= this.defaultShapes.length - 1 ? index : this.getRandomInt(0, this.defaultShapes.length - 1);
        const colorIndex = index <= this.defaultColors.length - 1 ? index : this.getRandomInt(0, this.defaultColors.length - 1);
        return {
          id: item.id,
          name: item.treatmentNumber,
          // name: `Treatment ${item.treatmentNumber}`,
          shape: this.defaultShapes[shapeIndex],
          color: this.defaultColors[colorIndex],
          wellId: this.wellItem.wellId,
          treatmentId: item.id,
          wellName: this.wellItem.wellName
        };
      });
      if (this.wellItem && this.wellItem.wellId) {
        this.loadSelectedTreatmentsDetail(this.selectedTreatments);
      } else {
        this.setupChartData(
          this.xAxisMode, this.selectedTreatments, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing,
          this.designActualData, this.groupOption
        );
      }
    }
  }

  @Input()
  set parameterItems(data: any[]) {
    if (data) {
      this.listParameters = data;
      this.listYAxisOptions = this.listParameters.map(item => {
        return {
          id: item,
          text: item
        };
      });
      const groupListParameters = this.wellsCompareDataService.toGroupParametersList(this.listYAxisOptions);
      this.listISIPOptions = groupListParameters.listISIPOptions;
      this.listPressureOptions = groupListParameters.listPressureOptions;
      this.listSlurryRateOptions = groupListParameters.listSlurryRateOptions;
      this.listMassOptions = groupListParameters.listMassOptions;
      this.listVolumeOptions = groupListParameters.listVolumeOptions;
      this.listProppantConcOptions = groupListParameters.listProppantConcOptions;
      this.listFDIOptions = groupListParameters.listFDIOptions;
      this.listTimeOptions = groupListParameters.listTimeOptions;
      if (isEmpty(this.selectedYAxisOption) && !isEmpty(this.listPressureOptions)) {
        let listPressureOptionsFormat = this.listPressureOptions.map(item => {
          return {
            id: item.id,
            text: item.text
          };
        });
        const avgPres = listPressureOptionsFormat.find(item => item.id === ENUM_TREATMENT_COLUMNS.AveragePres);

        if (avgPres) {
          this.selectedYAxisOption = [avgPres];
        } else {
          this.selectedYAxisOption = [listPressureOptionsFormat[0]];
        }

        this.yAxisOptionChange$.next(this.selectedYAxisOption);
      }
    }
  }
  selectedTemplate: any;
  @Output() scatterTemplatesChange: EventEmitter<boolean> = new EventEmitter();
  // pad mode
  @Input() padName: string;

  constructor(
    private dialogService: NbDialogService,
    private toasterService: ToasterService,
    private compareWellsService: CompareWellsService,
    private wellsCompareLogDataService: WellsCompareLogDataService,
    private treatmentService: TreatmentService,
    private logDataCurveParameterChartService: LogDataCurveParameterChartService,
    private scatterPlotParameterChartService: ScatterPlotParameterChartService,
    private treatmentLogParserService: TreatmentLogParserService,
    private wellsCompareDataService: WellsCompareDataService,
    private localDataStorageService: LocalDataStorageService,
    private compareParameterSingleService: CompareParameterSingleService,
    private realtimeTreatmentStorageService: RealtimeTreatmentStorageService
  ) {}

  private isLogDataFiles(prevous: any, current: any): boolean {
    if (!current || !current.wellId) return false;
    if (!prevous || prevous.wellId !== current.wellId) return true;
    return false;
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.destroy$.unsubscribe();
    this.compareParameterSingleService.setStorageCurve(null);
  }

  private getWellDetail(wellId: number): void {
    this.treatmentService.getWellDetail(wellId).subscribe(res => {
      if (res && res.result) {
        if (res.result.trajectory && res.result.trajectory.points) this.trajectoryData = res.result.trajectory.points;
        if (res.result.kickOfMD) this.logDataState.wellKickOfMD = res.result.kickOfMD;
      }
    });
  }

  private handleYAxisOptionChange(): void {
    this.yAxisOptionChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe(axisOption => {
        if (axisOption) {
          this.chartSettings.yAxis = axisOption.map((setting, yAxisIndex) => {
            const curSetting = this.chartSettings.yAxis.find(item => item.id === setting.id);
            if (curSetting) {
              return curSetting;
            } else {
              return this.getInitialAxisSetting(setting.id, setting.text, false, setting, yAxisIndex);
            }
          });
        } else {
          this.chartSettings.yAxis = [];
        }
        // trigger change detection
        this.chartSettings = Object.assign({}, this.chartSettings);
      });
  }

  private handleXAxisOptionChange(): void {
    this.xAxisOptionChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe(axisOption => {
        if (axisOption && axisOption[0]) {
          if (this.chartSettings.xAxis) {
            this.chartSettings.xAxis.id = axisOption[0].id;
            this.chartSettings.xAxis.name = axisOption[0].text;
          } else {
            this.chartSettings.xAxis = this.getInitialAxisSetting(axisOption[0].id, axisOption[0].text);
          }
        } else {
          this.chartSettings.xAxis = null;
        }
        // trigger change detection
        this.chartSettings = Object.assign({}, this.chartSettings);
      });
  }

  private handleCurveOptionChange(): void {
    this.curveOptionChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe(selectedCurve => {
        if (selectedCurve) {
          this.chartSettings.curveYAxis = selectedCurve.map(setting => {
            const curSetting = this.chartSettings.curveYAxis.find(item => item.id === setting.id);
            if (curSetting) {
              return curSetting;
            } else {
              const { shape, color, min, max } = setting;
              const result = this.getCurveAxisSetting({
                id: setting.id, name: setting.text, shape, color, min, max
              });
              return result;
            }
          });
        } else {
          this.chartSettings.curveYAxis = [];
        }
        // trigger change detection
        this.chartSettings = Object.assign({}, this.chartSettings);
      });
  }

  private handleDesignActualYAxisChange(): void {
    this.designActualOptionChange$
      .pipe(takeUntil(this.destroy$))
      .subscribe(axisOption => {
        if (axisOption) {
          this.chartSettings.designActualYAxis = axisOption.map((setting, yAxisIndex) => {
            const curSetting = this.chartSettings.designActualYAxis.find(item => item.id === setting.id);
            if (curSetting) {
              return curSetting;
            } else {
              return this.getInitialAxisSetting(setting.id, setting.text, false, setting, yAxisIndex, true);
            }
          });
        } else {
          this.chartSettings.designActualYAxis = [];
        }
        // trigger change detection
        this.chartSettings = Object.assign({}, this.chartSettings);
      });
  }

  ngOnInit(): void {
    this.setupChartData(this.xAxisMode, this.selectedTreatments, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing);
    // get well trajectory data
    if (this.wellItem && this.wellItem.wellId) {
      this.listLogDataFiles$ = this.wellsCompareLogDataService.getLogDataFiles(this.wellItem.wellId);
      this.getWellDetail(this.wellItem.wellId);
    }
    // handle y axis option change
    this.handleYAxisOptionChange();
    // handle x axis option change
    this.handleXAxisOptionChange();
    // handle curve option change
    this.handleCurveOptionChange();
    // handle design actual option change
    this.handleDesignActualYAxisChange();
    // get design actual setting
    const localDesignActual = this.localDataStorageService.getOption(KEY_DESIGN_ACTUAL_SETTING);
    if (localDesignActual) {
      this.designActualSettings = localDesignActual;
    }
    // get templates
    if (this.padName) {
      this.selectedTemplate = this.realtimeTreatmentStorageService.getOption(this.padName, KEY_TEMPLATE, PAD_COMPARE_PARAM_SINGLE_WELL);
      if (this.selectedTemplate) {
        this.onSelectTemplate(this.selectedTemplate);
      }
    }
    this.getTreatmentLogTemplates();
  }

  private getInitialAxisSetting(id, name, isCurve?: boolean, obj = {}, yAxisIndex = 0, isDesignActual = false): IAxisSetting {
    const shape = DefaultShapes[yAxisIndex];
    const color = DefaultColor[yAxisIndex];
    const result: IAxisSetting = {
      id: id,
      name: name,
      color: color,
      shape: shape,
    };
    if (isCurve) {
      result.color = '#FF8000';
      result.shape = 'Triangle';
    }
    if (isDesignActual) {
      result.designShape = this.designActualSettings.designShape || DEFUALT_DESIGN_ACUTAL_SHAPES[0].id;
      result.actualShape = this.designActualSettings.actualShape || DEFUALT_DESIGN_ACUTAL_SHAPES[0].id
      result.designColor = this.designActualSettings.designColor || DEFAULT_DESIGN_COLOR;
      result.actualColor = this.designActualSettings.actualColor || DEFAULT_ACTUAL_COLOR;
    }

    return Object.assign(obj, result);
  }

  getYAxisSettings(axisOption, isCurve?: boolean, startIndex = 0, isDesignActual = false) {
    const settings = axisOption.map((setting, yAxisIndex) => {
      const curSetting = this.chartSettings.yAxis.find(item => item.id === setting.id);
      if (curSetting) {
        return curSetting;
      } else {
        return this.getInitialAxisSetting(setting.id, setting.text || setting.name, isCurve, setting, yAxisIndex + startIndex, isDesignActual);
      }
    });

    return settings;
  }

  getCurveAxisSetting({ id, name, color, shape, min, max }): IAxisSetting {
    const result: IAxisSetting = {
      id: id,
      name: name,
      color: color || '#FF8000',
      shape: shape || 'Triangle',
      min,
      max
    };

    return result;
  }

  onChangeXAxisOption(item) {
    if (item) {
      const isDuplicated = this.checkIsDuplicateParameter(this.selectedYAxisOption[0], item);
      if (!isDuplicated) {
        this.selectedXAxisOption = [item];
        let xAxis: any;
        if (item.id || item.id === 'time' || item.id === 'well') {
          this.xAxisMode = 'time';
          xAxis = this.getInitialAxisSetting(this.listXAxisOptions[0].id, this.listXAxisOptions[0].text);
          if (this.chartSettings) {
          }
        } else {
          this.xAxisMode = 'parameter';
          xAxis = item;
        }
        if (this.chartSettings) {
          this.chartSettings.xAxis = xAxis;
        } else {
          this.chartSettings = {
            xAxis,
            yAxis: [],
            curveYAxis: [],
            designActualYAxis: []
          };
        }
        this.saveTemplateStorage({ xAxis: this.chartSettings.xAxis });
        this.xAxisOptionChange$.next(this.selectedXAxisOption);
        this.setupChartData(
          this.xAxisMode, this.selectedTreatments, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing,
          this.designActualData, this.groupOption
        );
      } else {
        this.toasterService.showError(`${item.text} already exists`);
      }
    }
  }

  onChangeYAxisOption(option: IModelSelectParameters) {
    if (option && option.selected) {
      this.selectedYAxisOption = option.selected;
      const paramFDIs = Object.values(OBJ_FDI_PARAMS);
      const pureYAxis = this.selectedYAxisOption.filter(opt => !paramFDIs.includes(opt.id));
      this.chartSettings.yAxis = this.getYAxisSettings(pureYAxis);
      if (option.designActual && !isEmpty(option.designActual.selected)) {
        this.selectedDesignActualYAxisOption = option.designActual.selected;
        const designActualAxis = option.designActual.selected.map(item => {
          return Object.assign(item, { type: ENUM_AXIS_TYPE.DesignActual });
        });
        this.chartSettings.designActualYAxis = this.getYAxisSettings(designActualAxis, this.chartSettings.curveYAxis.length > 0, this.chartSettings.yAxis.length, true);
        this.yAxisOptionChange$.next(option.selected);
        this.designActualOptionChange$.next(designActualAxis);
        this.loadSelectedTreatmentsDetail(this.selectedTreatments);
      } else {
        this.designActualData = null;
        this.yAxisOptionChange$.next(this.selectedYAxisOption);
        this.setupChartData(this.xAxisMode, this.selectedTreatments, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing, this.designActualData, this.groupOption);
      }
      // save template
      if (this.chartSettings) {
        if (this.selectedTemplate && this.selectedTemplate.content) {
          this.saveTemplateStorage({ yAxis: this.chartSettings.yAxis, designActualYAxis: this.chartSettings.designActualYAxis });
        } else {
          this.saveTemplateStorage(this.chartSettings);
        }
      }
    }
  }

  private loadSelectedTreatmentsDetail(selectedTreatments = []): void {
    if (!selectedTreatments) return;
    if (!this.treatmentDetailsStored) this.treatmentDetailsStored = {};
    const treatmentDetailStorageS = this.wellsCompareDataService.getTreatmentSelectDetails();
    const treatments: {treatmentId: number, treatmentNumber: number, treatmentName?: string}[] = [];

    for (const treatment of selectedTreatments) {
      if (!!this.treatmentDetailsStored[treatment.id]) continue;
      if (treatmentDetailStorageS[treatment.id]) this.treatmentDetailsStored[treatment.id] = treatmentDetailStorageS[treatment.id];
      else treatments.push({treatmentId: treatment.id, treatmentNumber: treatment.treatmentNumber, treatmentName: treatment.treatmentName});
    }

    if (!treatments.length) {
      this.treatmentAvgMDItems = this.getLocalListTreatmentDetails(selectedTreatments, this.treatmentDetailsStored);
      this.designActualData = this.treatmentAvgMDItems;
      this.setupChartData(this.xAxisMode, this.selectedTreatments, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing, this.designActualData, this.groupOption);
    } else {
      this.wellsCompareLogDataService.getTreatmentsDataForCompareWell(this.wellItem.wellId, treatments)
        .subscribe(results => {
          // update treatment avgMD data
          results.forEach(treatment => { this.treatmentDetailsStored[treatment.id] = treatment; });
          this.wellsCompareDataService.setTreatmentSelectedDetail(this.treatmentDetailsStored);

          this.treatmentAvgMDItems = this.getLocalListTreatmentDetails(selectedTreatments, this.treatmentDetailsStored);
          this.designActualData = this.treatmentAvgMDItems;
          this.setupChartData(this.xAxisMode, this.selectedTreatments, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing, this.designActualData, this.groupOption);
        });
    }
  }

  private getLocalListTreatmentDetails(selectedTreatments: any[], treatmentDetailsStored): any[] {
    if (!selectedTreatments || !selectedTreatments.length || !treatmentDetailsStored) return [];

    const treatmentDetails: any[] = Object.values(treatmentDetailsStored);
    const selectedTreatmentIds = selectedTreatments.map(trm => trm.id);
    return treatmentDetails.filter(item => includes(selectedTreatmentIds, item.id));
  }

  onChangeGroupsOption(opt: string) {
    if (this.groupOption !== opt) {
      this.groupOption = opt;
      this.setScatterPlotChartInputState(
        this.xAxisMode, this.itemsComparing, this.chartSettings, this.inputChartData, this.logDataState,
        this.designActualData, this.groupOption
      );
    }
  }

  toggleDisplayTooltip(event) {
    this.isDisplayTooltip = !this.isDisplayTooltip;
    this.scatterHighChart.toggleTooltip(this.isDisplayTooltip);
  }

  zoomOut() {
    this.scatterHighChart.zoomOut();
  }

  reflow() {
    this.scatterHighChart.reflow();
  }

  private setScatterPlotChartInputState(
    xAxisMode: string, itemsComparing, chartSettings, inputData, logDataState?,
    designActualData?, groupOption?
  ): void {
    try {
      this.scatterChartInputState = {
        ...this.scatterChartInputState,
        xAxisMode,
        chartSettings,
        itemsComparing: [...itemsComparing],
        inputData: inputData ? [...inputData] : [],
        logDataState: logDataState,
        designActualData,
        groupOption
      };
    } catch (err) {
      console.error(err);
    }
  }

  private setupChartData(xAxisMode: string, selectedTreatments: any[], selectedXAxisOption, selectedYAxisOption, itemsComparing, designActualData?: any[], groupOption?): void {
    const selectedParameters = this.getSelectedPararmeters(selectedXAxisOption, selectedYAxisOption);
    if (!selectedTreatments || !selectedTreatments.length || !selectedParameters.length) {
      if (!designActualData || !designActualData.length) this.scatterHighChart.resetChart(true);
      else {
        this.setScatterPlotChartInputState(
          xAxisMode, itemsComparing, this.chartSettings, this.inputChartData, this.logDataState,
          designActualData, groupOption
        );
      }
      return;
    }

    const param: any = {
      treatmentIds: selectedTreatments.map(item => (item.id)),
      listParam: selectedParameters.map(item => (item.id)),
    };
    this.getChartData(param, xAxisMode, itemsComparing, designActualData, groupOption);
  }

  private getChartData(param: any, xAxisMode: string, itemsComparing, designActualData?: any[], groupOption?
  ): void {
    this.compareWellsService.compareSingleWellChart(param)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res && res.result) {
            this.inputChartData = res.result.map(item => {
              // find avg md item
              const avgMDItem = this.treatmentAvgMDItems.find(md => md.id === item.treatmentId);
              if (avgMDItem) {
                item.avgMDValue = avgMDItem.avgMD;
              }
              item.id = item.treatmentId;
              item.name = `Treatment ${item.treatmentNumber}`;
              // datetime parameter
              if (EpochTimeParameters.indexOf(item.paramName) > -1) {
                item.paramUnit = '(datetime)';
              } else { // offset parameter
                // convert unit sec to min
                if (item.paramUnit && item.paramUnit.indexOf('sec') > -1) {
                  item.paramUnit = '(min)';
                  item.paramValue = item.paramValue / 60;
                }
                if (item.paramName === 'TotalPumpTime') {
                  item.paramUnit = '(min)';
                  item.paramValue = item.paramValue / 60;
                }
              }

              return item;
            });
            if (this.logDataState && !isEmpty(this.selectedCurve)) {
              if (this.selectedLogFile && this.selectedLogFile[0]) {
                this.handleLoadLogDataState(this.selectedLogFile[0].id, this.selectedCurve);
              }
            } else {
              this.setScatterPlotChartInputState(
                xAxisMode, itemsComparing, this.chartSettings, this.inputChartData, this.logDataState,
                designActualData, groupOption
              );
            }
          }
        });
  }

  private getSelectedPararmeters(xAxisOption: any[], yAxisOption: any[]): any[] {
    if (isEmpty(xAxisOption) || isEmpty(yAxisOption)) return [];

    const xAxisParameters = xAxisOption.filter(item => item.id && item.id !== 'time' && item.id !== 'well');
    return xAxisParameters.concat(yAxisOption);
  }

  public showChartSettings(): void {
    this.dialogService.open(ScatterPlotParameterSettingsComponent, {
      context: {
        chartSettings: cloneDeep(this.chartSettings)
      }
    }).onClose.subscribe(res => {
      if (res && !isEqual(this.chartSettings, res)) {
        this.chartSettings = res;
        if (this.padName && this.selectedTemplate && this.chartSettings) {
          this.selectedTemplate.content = this.chartSettings;
          this.realtimeTreatmentStorageService.setOption(this.padName, KEY_TEMPLATE, this.selectedTemplate, PAD_COMPARE_PARAM_SINGLE_WELL);
        }
        // save design actual setting in local
        if (this.chartSettings.designActualYAxis && !isEmpty(this.chartSettings.designActualYAxis)) {
          this.designActualSettings = {
            designShape: this.chartSettings.designActualYAxis[0].designShape,
            actualShape: this.chartSettings.designActualYAxis[0].actualShape,
            designColor: this.chartSettings.designActualYAxis[0].designColor,
            actualColor: this.chartSettings.designActualYAxis[0].actualColor
          };
          this.localDataStorageService.setOption(KEY_DESIGN_ACTUAL_SETTING, this.designActualSettings);
        }
        this.setScatterPlotChartInputState(
          this.xAxisMode, this.itemsComparing, this.chartSettings, this.inputChartData, this.logDataState,
          this.designActualData, this.groupOption
        );
      }
    });
  }

  private checkIsDuplicateParameter(curParam, newParam): boolean {
    if (!curParam || !newParam) return false;
    return curParam.id === newParam.id;
  }

  private getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  public onExport(eventData: string): void {
    if (eventData === 'Raw Data') {
      let textContent = '';

      if (!isEmpty(this.logDataState.curveData)) {
        textContent = this.logDataCurveParameterChartService.getRawStringScale(this.logDataState, this.inputChartData);
      } else {
        textContent = this.scatterPlotParameterChartService.getRawStringNonScale(
          this.inputChartData, this.selectedXAxisOption, this.selectedYAxisOption, this.selectedTreatments,
          this.chartSettings.designActualYAxis[0], this.designActualData
        );
      }

      if (textContent) {
        let file = new Blob([textContent], { type: "text/plain;charset=utf-8" });
        let fileName = this.wellItem.wellName + '_' + new Date().getTime() + '.txt';

        saveAs(file, fileName);
      }

    } else {
      let data = '';
      if (this.selectedTreatments.length > 2) {
        data = moment(new Date()).format('MM-DD-YYYY');
      } else {
        data = this.selectedTreatments.map(item => item.treatmentName).join('_');
      }
      let fileName = `Compare_Parameters`;
      if (this.wellItem && this.wellItem.wellName) {
        fileName = `${fileName}_${this.wellItem.wellName}_${data}`;
      } else {
        fileName = `${fileName}_${data}`;
      }
      this.scatterHighChart.exportChart(`${fileName}`, eventData);
    }
  }

  onChangeScaleOption(item) {
    if (item) {
      this.selectedScaleOption = [item];
      this.logDataState.scaleMode = item.id;
      if (this.selectedLogFile && this.selectedLogFile[0] && !isEmpty(this.selectedCurve)) {
        this.handleLoadLogDataState(this.selectedLogFile[0].id, this.selectedCurve);
      }
      // trigger change detection
      this.chartSettings = {
        ...this.chartSettings,
        scale: [item.id]
      };
      this.saveTemplateStorage({ scale: [item.id] });
    }
  }

  onChangeLogFile(file) {
    if (file && file.id) {
      this.selectedLogFile = [file];
      this.listCurves$ = this.wellsCompareLogDataService.getListCurves(file.id, this.wellItem.wellId).pipe(tap(res => {
        this.listCurves = res;
        this.isDisabledXAxisOption = res.length > 0;
      }));
    } else {
      this.selectedLogFile = [];
      this.listCurves$ = of([]);
      this.listCurves = [];
      this.isDisabledXAxisOption = false;
    }
    this.selectedCurve = [];
    this.logDataState.curveData = [];
    this.logDataState.curveItem = null;
    this.logDataState.selectedCurves = this.selectedCurve = [];
    this.curveOptionChange$.next(null);
    this.setScatterPlotChartInputState(
      this.xAxisMode,
      this.itemsComparing,
      this.chartSettings,
      this.inputChartData,
      this.logDataState,
      this.designActualData,
      this.groupOption
    );
  }

  setSelectedCurveStateChanges(newItems) {
    this.selectedCurve = newItems.map(item => {
      const curveItem = this.listCurves.find(curve => curve.id === item.id);
      if (curveItem) {
        return Object.assign(item, {
          name: curveItem.text || curveItem.name,
          text: curveItem.text || curveItem.name,
          unit: curveItem.unit
        });
      }
      return item;
    });
    this.logDataState.selectedCurves = this.selectedCurve;
    this.curveOptionChange$.next(this.selectedCurve);
  }

  onChangeCurveOption(items) {
    if (items) {
      this.setSelectedCurveStateChanges(items);
      if (this.selectedLogFile && this.selectedLogFile[0]) {
        this.handleLoadLogDataState(this.selectedLogFile[0].id, this.selectedCurve);
      }

      if (this.selectedScaleOption) {
        this.chartSettings.scale = [this.selectedScaleOption[0].id];
      }

      this.chartSettings = Object.assign({}, this.chartSettings);
      this.saveTemplateStorage(this.chartSettings);
    }
  }

  private handleLoadLogDataState(selectedLogFile, selectedCurve): void {
    if (!selectedCurve || isEmpty(selectedCurve)) {
      // unset log data
      this.logDataState.logCurvesData = [];
      this.setScatterPlotChartInputState(
        this.xAxisMode,
        this.itemsComparing,
        this.chartSettings,
        this.inputChartData,
        this.logDataState,
        this.designActualData,
        this.groupOption
      );
      return;
    }
    let isStorageData: boolean = false
    const dataSelectedCurves = selectedCurve;
    // side effect get log cure data
    const req$: Observable<ILogCurvesParam> = selectedCurve.map(curve => {
      let result = undefined;
      if (this.compareParameterSingleService.getStorageCurve()) {
        result = this.compareParameterSingleService.getStorageCurve();
      };
      const curves = dataSelectedCurves.map(item => item.id);
      if (result) {
        if (this.compareParameterSingleService.isCheckStorageCurveData(result.selectedLogFile, selectedLogFile, result.selectedCurve, curves)) {
          isStorageData = true;
        }
        else {
          isStorageData = false;
          return this.getLogDataCurve(selectedLogFile, this.wellItem.wellId, curve);
        }
      }
      else {
        isStorageData = false;
        return this.getLogDataCurve(selectedLogFile, this.wellItem.wellId, curve);
      }
    });
    this.setLocalStorageAndHandleLogCurves(isStorageData, req$, dataSelectedCurves, selectedLogFile);
  }

  getLogDataCurve(selectedLogFile, wellId, curve) {
    return this.wellsCompareLogDataService.getLogDataCurve(selectedLogFile, wellId, curve.id)
      .pipe(map(res => {
        return { id: curve.id, name: curve.name, values: res.values }
      }))
  }

  setLocalStorageAndHandleLogCurves(isStorageData, req$, dataSelectedCurves, selectedLogFile) {
    if (isStorageData === false) {
      forkJoin(req$)
        .pipe(takeUntil(this.destroy$))
        .subscribe(logCurves => {
          const curves = dataSelectedCurves.map(item => item.id);
          let dataStorage = { selectedLogFile, logCurves, selectedCurve: curves }
          this.compareParameterSingleService.setStorageCurve(dataStorage);
          this.handleSetScatterPlot(logCurves);
        });
    }
    else {
      const result = this.compareParameterSingleService.getStorageCurve();
      this.handleSetScatterPlot(result.logCurves);
    }
  }

  handleSetScatterPlot(logCurves) {
    if (this.logDataState.scaleMode === ENUM_SCALE_TYPES.Treatment) {
      const logCurvesData = this.treatmentLogParserService.parseCurveDataByTreatment(logCurves, this.treatmentAvgMDItems);
      this.logDataState.logCurvesData = logCurvesData;
      // emit x axis changed
      // this.xAxisOptionChange$.next(null);
      this.selectedScaleOption = [{ id: ENUM_SCALE_TYPES.Treatment, text: ENUM_SCALE_TYPES.Treatment }];
    } else if (this.logDataState.scaleMode === ENUM_SCALE_TYPES.VerticalSection) {
      // emit x axis changed
      // this.xAxisOptionChange$.next([{ id: ENUM_SCALE_TYPES.VerticalSection, text: ENUM_SCALE_TYPES.VerticalSection }]);
      this.selectedScaleOption = [{ id: ENUM_SCALE_TYPES.VerticalSection, text: ENUM_SCALE_TYPES.VerticalSection }];
      // parse data
      const parsedData = this.treatmentLogParserService.parseDataByVerticalSection(
        logCurves, this.treatmentAvgMDItems, this.trajectoryData, this.inputChartData
      );
      // set parameter data
      this.logDataState.parameterData = parsedData.parameterData;
      // set log curve data
      this.logDataState.logCurvesData = parsedData.curveData;
    } else if (this.logDataState.scaleMode === ENUM_SCALE_TYPES.MeasuredDepth) {
      // this.xAxisOptionChange$.next([{ id: ENUM_SCALE_TYPES.MeasuredDepth, text: ENUM_SCALE_TYPES.MeasuredDepth }]);
      this.selectedScaleOption = [{ id: ENUM_SCALE_TYPES.MeasuredDepth, text: ENUM_SCALE_TYPES.MeasuredDepth }];
      // parse data
      const parsedData = this.treatmentLogParserService.parseDataByMeasuredDepth(
        logCurves, this.treatmentAvgMDItems, this.trajectoryData, this.inputChartData
      );
      // set parameter data
      this.logDataState.parameterData = parsedData.parameterData;
      // set log curve data
      this.logDataState.logCurvesData = parsedData.curveData;
    }
    this.setScatterPlotChartInputState(
      this.xAxisMode,
      this.itemsComparing,
      this.chartSettings,
      this.inputChartData,
      this.logDataState,
      this.designActualData,
      this.groupOption
    );
  }

  onSelectTemplate(templateRes: ITreatmentLogTemplateResponse) {
    this.selectedTemplate = templateRes;
    if (this.padName) {
      this.realtimeTreatmentStorageService.setOption(this.padName, KEY_TEMPLATE, this.selectedTemplate, PAD_COMPARE_PARAM_SINGLE_WELL);
    }
    if (templateRes && templateRes.content) {
      const template = templateRes.content;
      if (template) {
        if (template.curveYAxis) {
          template.curveYAxis = template.curveYAxis.map(item => {
            item.name = item.id;
            item.text = item.id;
            item.shapeTemp = [
              {
                id: item.shape,
                name: item.shape
              }
            ];
            return item;
          });

          this.chartSettings.curveYAxis = template.curveYAxis;
          this.onChangeCurveOption(template.curveYAxis);
        }
        // xAxis
        if (isEmpty(template.xAxis) || !template.xAxis.id || template.xAxis.id === 'time' || template.xAxis.id === 'well') {
          this.xAxisMode = 'time';
          this.chartSettings.xAxis = this.getInitialAxisSetting(this.listXAxisOptions[0].id, this.listXAxisOptions[0].text);
        } else {
          this.xAxisMode = 'parameter';
          this.chartSettings.xAxis = template.xAxis;
        }
        this.selectedXAxisOption = [this.chartSettings.xAxis].map(item => {
          return Object.assign({ text: item.name }, item);
        });
        // yAxis
        this.chartSettings.yAxis = template.yAxis;
        this.selectedYAxisOption = template.yAxis.map(item => {
          return Object.assign({ text: item.name }, item);
        });
        // design Actual yAxis
        if (template.designActualYAxis) {
          this.chartSettings.designActualYAxis = template.designActualYAxis;
        } else {
          this.chartSettings.designActualYAxis = [];
        }
        this.selectedDesignActualYAxisOption = this.chartSettings.designActualYAxis.map(item => {
          return Object.assign({ text: item.name }, item);
        });

        // load scale mode
        if (!isEmpty(template.scale)) {
          this.selectedScaleOption = template.scale;
          this.logDataState.scaleMode = template.scale[0];
        } else {
          this.selectedScaleOption = [this.listScaleTypes[0]];
          this.logDataState.scaleMode = ENUM_SCALE_TYPES.VerticalSection;
        }
        // load curve option
        if (!isEmpty(template.curveYAxis)) {
          this.setSelectedCurveStateChanges(template.curveYAxis);
        } else {
          this.setSelectedCurveStateChanges([]);
        }

        this.chartSettings = Object.assign({}, this.chartSettings);
        this.setupChartData(
          this.xAxisMode, this.selectedTreatments, this.selectedXAxisOption, this.selectedYAxisOption, this.itemsComparing,
          this.designActualData, this.groupOption
        );
      }
    }
  }

  onTemplatesChange(eventData): void {
    this.scatterTemplatesChange.emit(true);
  }

  private getTreatmentLogTemplates(): void {
      this.treatmentLogParserService.scatterPlotTemplatesData$.subscribe((data: ITreatmentLogTemplateResponse[]) => {
        this.dataTreatmentLogTemplates = data;
        if (this.padName && !this.selectedTemplate) {
          this.saveTemplateStorage();
          this.onSelectTemplate(this.selectedTemplate);
        }
      });
  }

  private saveTemplateStorage(content?: any): void {
    if (this.padName) {
      if (!this.selectedTemplate) {
        this.selectedTemplate = this.dataTreatmentLogTemplates && this.dataTreatmentLogTemplates.length > 0 ? this.dataTreatmentLogTemplates[0] : {
          id: null,
          content: {
            id: null,
            name: null,
            xAxis: null,
            yAxis: [],
            curveYAxis: [],
            designActualYAxis: [],
            scale: [],
            fdiYAxis: [],
          },
          type: null,
          name: null
        };
      } else if (!this.selectedTemplate.content) {
        this.selectedTemplate.content = {
          id: null,
          name: null,
          xAxis: null,
          yAxis: [],
          curveYAxis: [],
          designActualYAxis: [],
          scale: [],
          fdiYAxis: [],
        };
      }
      if (content) {
        each(content, (value, key) => {
          if (this.selectedTemplate.content.hasOwnProperty(key)) {
            this.selectedTemplate.content[key] = value;
          }
        });
      }
      this.realtimeTreatmentStorageService.setOption(this.padName, KEY_TEMPLATE, this.selectedTemplate, PAD_COMPARE_PARAM_SINGLE_WELL);
    }
  }

}
